import { useEffect, useRef } from 'react';

/**
 * A hook to save and restore the scroll position of a container.
 * 
 * @param {string} key - The storage key to use for saving the scroll position.
 * @param {boolean} isFetched - A flag indicating if the data has been loaded and the container is ready.
 * @returns {Object} - An object containing the ref to attach to the scrollable container and the scroll handler.
 */
export function useScrollRestoration(key, isFetched) {
  const containerRef = useRef(null);

  // Restore scroll position
  useEffect(() => {
    if (isFetched && containerRef.current) {
      const savedScroll = sessionStorage.getItem(key);
      if (savedScroll) {
        containerRef.current.scrollTop = parseInt(savedScroll, 10);
      }
    }
  }, [isFetched, key]);

  // Save scroll position on scroll
  const handleScroll = (e) => {
    sessionStorage.setItem(key, e.target.scrollTop);
  };

  return { containerRef, handleScroll };
}
